<template>
	<div>
		<div class="linesdoubley_echarts" :id="echartsId"></div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: ['echartsId', 'echartsData'],
	data() {
		return {};
	},
	computed: {},
	watch: {
		echartsData: {
			handler(to) {
				if (to) {
					this.getEcharts(to);
				}
			},
		},
	},
	mounted() {
		this.getEcharts();
	},
	methods: {
		getEcharts(datas) {
			var chartDom = document.getElementById(this.echartsId);
			var myChart = this.$echarts.init(chartDom);
			if (datas) {
				var unit = datas.unit;
				var legends = datas.legend;
				var category = datas.category;
				var lineData = datas.lineData;
				var barData = datas.barData;

				// 只保留当前年份往前推五年的数据（包含当前年份）
				var currentYear = new Date().getFullYear();
				var startYear = currentYear - 5;
				var filteredCategory = [];
				var filteredLineData = [];
				var filteredBarData = [];
				for (var i = 0; i < category.length; i++) {
					var year = parseInt(category[i].substring(0, 4), 10);
					if (year >= startYear && year <= currentYear) {
						filteredCategory.push(category[i]);
						filteredLineData.push(lineData[i]);
						filteredBarData.push(barData[i]);
					}
				}
				category = filteredCategory;
				lineData = filteredLineData;
				barData = filteredBarData;

				let option = {
					title: {
						text: '',
						x: 'center',
						y: 0,
						textStyle: {
							color: '#B4B4B4',
							fontSize: 16,
							fontWeight: 'normal',
						},
					},
					tooltip: {
						trigger: 'axis',

						// backgroundColor: 'rgba(255,255,255,0.1)',
						axisPointer: {
							type: 'shadow',
							label: {
								show: true,
								backgroundColor: '#7B7DDC',
							},
						},
						formatter: function(param) {
							console.log(param);
							return `${param[0].axisValueLabel}<br/>${param[0].marker} ${param[0].seriesName} : ${param[0].value} ${unit[0]}<br/>${param[1].marker} ${param[1].seriesName} : ${param[1].value} ${unit[1]}`;
						},
					},
					legend: {
						data: legends,
						textStyle: {
							color: 'rgba(51, 51, 51, 1)',
							fontSize: 11,
						},
						left: '0',
						itemGap: 6,
						itemWidth: 5,
						itemHeight: 5,
						bottom: '0',
						orient: 'vertical',
					},
					grid: {
						top: '3%',
						left: '0',
						right: '0',
						bottom: '19%',
						containLabel: true,
					},
					xAxis: {
						data: category,
						axisLine: {
							lineStyle: {
								color: 'rgba(51, 51, 51, 1)',
							},
						},
						axisLabel: {
							padding: [0, 0, 0, 12],
							fontSize: 10,
						},
						axisTick: {
							show: false,
						},
					},
					yAxis: [
						{
							// name: unit[0],
							// nameLocation: 'end',
							// nameTextStyle: {
							// 	color: 'rgba(51, 51, 51, 1)',
							// 	fontSize: 11,
							// 	align: 'left',
							// },
							splitLine: { show: false },
							axisLine: {
								lineStyle: {
									color: '#B4B4B4',
								},
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
								color: 'rgba(51, 51, 51, 1)',
								// formatter: function(value, index) {
								// 	return value / 10000;
								// },
							},
						},
						{
							// name: unit[1],
							// nameLocation: 'end',
							// nameTextStyle: {
							// 	color: 'rgba(51, 51, 51, 1)',
							// 	fontSize: 11,
							// 	align: 'right',
							// },
							splitLine: { show: true },
							axisLine: {
								lineStyle: {
									color: '#B4B4B4',
								},
							},
							axisTick: {
								show: false,
							},
							axisLabel: {
								color: 'rgba(51, 51, 51, 1)',
							},
						},
					],

					series: [
						{
							name: legends[0],
							type: 'line',
							smooth: true,
							showAllSymbol: false,
							symbol: 'emptyCircle',
							symbolSize: 0,
							yAxisIndex: 1,
							itemStyle: {
								normal: {
									color: '#91c7ae',
								},
							},
							data: lineData,
						},

						{
							name: legends[1],
							type: 'line',
							smooth: true,
							showAllSymbol: false,
							symbol: 'emptyCircle',
							symbolSize: 0,

							itemStyle: {
								normal: {
									barBorderRadius: 5,
									color: '#2f4554',
								},
							},
							data: barData,
						},
					],
				};
				//console.log(option);
				myChart.setOption(option);
			}
		},
	},
};
</script>
<style lang="less" scoped>
.linesdoubley_echarts {
	width: 243px;
	height: 220px;
}
#linesdoubley_echarts2 {
	width: 233px;
}
</style>



// WEBPACK FOOTER //
// src/view/index/components/doubleLins/index.vue